import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { Theme } from '@mui/material/styles';
import * as React from 'react';
import { makeStyles } from 'tss-react/mui';
import { ContactType } from '../../../../../sic-lib/enums/ContactType';
import { ContactFieldValue } from '../../../../../sic-lib/types/ContactField';

const useStyles = makeStyles()((theme: Theme) => ({
    item: {
        '&:hover': {
            backgroundColor: theme.palette.menuListHover.light,
        },
        '&.Mui-selected': {
            backgroundColor: theme.palette.menuListHover.main,
            '&:hover': {
                backgroundColor: theme.palette.menuListHover.main,
            },
        },
    },
}));

interface Props {
    typeId: ContactFieldValue | null;
    menuId: string;
    anchorEl: HTMLElement | null;
    onChangeHandler: (event: React.MouseEvent<HTMLElement>) => void;
    onCloseHandler: () => void;
}

export default function MenuSetContactTypeRaw({
    typeId,
    menuId,
    anchorEl,
    onChangeHandler,
    onCloseHandler,
}: Props) {
    const { classes } = useStyles();

    const contactType = Object.keys(ContactType).filter(key => {
        return isNaN(Number(key));
    });

    return (
        <Menu id={menuId} anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={onCloseHandler}>
            {contactType.map(itm => (
                <MenuItem
                    key={itm}
                    data-type-id={itm}
                    selected={itm === ContactType[typeId as keyof typeof ContactType].toString()}
                    onClick={onChangeHandler}
                    className={classes.item}
                >
                    {itm === 'Undefined' ? 'Unknown' : itm}
                </MenuItem>
            ))}
        </Menu>
    );
}
